import { useQuery } from "@tanstack/react-query";
import { facilityApi } from "@bw/shared/api";
import type { CourtResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * A facility's courts in the backend's canonical order. The enabled-court filter
 * happens in `buildSheetModel`; neither hook nor model reorders server state.
 */
export function useCourts(facilityId: string | undefined) {
  return useQuery<CourtResponse[]>({
    queryKey: queryKeys.booking.courts(facilityId ?? ""),
    queryFn: () => facilityApi.listCourts(facilityId as string),
    enabled: Boolean(facilityId),
  });
}
